import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { getTenant } from '../../../../../../../configuration/login/loginSlice';
import type { NewIdentification, Tag } from '../../../../../../../types';
import { getShowUserCreation } from '../../../../../../Drivers.selectors';
import {
    changeEmail,
    changeFirstName,
    changeLastName,
    changeNewIdentification,
    changePhoneNumber,
    getFormErrorsRtk,
    getNewIdentificationValueRtk,
    getPendingIdentificationDeletionsRtk,
    getSelectedDriverRtk,
    getShowIdentificationCreationRtk,
    isFetchDriverInProgressRtk,
    setShowNotificationCreation,
    togglePendingIdentificationDeletion,
} from '../../../sidebarSlice';
import type {
    DriverInfoFormPropertiesFromDispatch,
    DriverInfoFormPropertiesFromState,
} from '../../types/driverInfoFormTypes';
import { DriverInfoForm } from '../components/DriverInfoForm';
import { getDriversRtk } from '../../../../../appSlice';
import { setTagsToRemoveThunk } from '../../../../../../crossSliceThunks';

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
const mapStateToProps = (state: any): DriverInfoFormPropertiesFromState => ({
    fetchDriverInProgress: isFetchDriverInProgressRtk(state),
    formErrors: getFormErrorsRtk(state),
    selectedDriver: getSelectedDriverRtk(state),
    pendingDeletions: getPendingIdentificationDeletionsRtk(state),
    newIdentificationValue: getNewIdentificationValueRtk(state),
    showIdentificationCreation: getShowIdentificationCreationRtk(state),
    showUserCreation: getShowUserCreation(state),
    tenant: getTenant(state),
    existingDrivers: getDriversRtk(state),
});

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
const mapDispatchToProps = (dispatch: any): DriverInfoFormPropertiesFromDispatch => ({
    changeFirstName: (firstName: string) => dispatch(changeFirstName(firstName)),
    changeLastName: (lastName: string) => dispatch(changeLastName(lastName)),
    changePhoneNumber: (phoneNumber: string) => dispatch(changePhoneNumber(phoneNumber)),
    changeEmail: (email: string) => dispatch(changeEmail(email)),
    togglePendingDeletion: (identificationId: string) =>
        dispatch(togglePendingIdentificationDeletion(identificationId)),
    changeNewIdentificationValue: (identificationValue: NewIdentification | null) =>
        dispatch(changeNewIdentification(identificationValue)),
    removeTag: (tags: Tag[]) => dispatch(setTagsToRemoveThunk(tags)),
    setShowNotificationCreation: (show: boolean) => dispatch(setShowNotificationCreation(show)),
});

export const DriverInfoFormContainer = connect(mapStateToProps, mapDispatchToProps)(injectIntl(DriverInfoForm));
